import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

import defaultColor from './defaultColor';

export default function IncreaseIcon(props) {
  const color = props.color === 'secondary' ? '#b1b1b1' : props.color;
  return <SvgIcon {...props} viewBox="0 0 14 14" fill="none">
    <path id="Vector 334" stroke={color || defaultColor} fill="none" strokeLinecap="round" strokeLinejoin="round"
          d="M12.7313 1.55729c-0.0441 0.06759 -4.59157 6.66316 -5.37571 7.21502 -1.02787 0.7234 -1.50644 -2.20844 -2.70205 -2.11494C3.1652 6.77377 0.530522 12.4525 0.5 12.501"
          strokeWidth="1"></path>
    <path id="Vector" stroke={color || defaultColor} fill="none" strokeLinecap="round" strokeLinejoin="round"
          d="M8.84814 2.29236c1.09785 -0.62946 2.65556 -0.92473 3.89426 -0.7382 0.6009 1.15021 0.8827 2.78223 0.7047 4.08006"
          strokeWidth="1"></path>
  </SvgIcon>
}
